module.exports = __webpack_public_path__ + "img/coupon.05e13a3a.svg";